import { render, staticRenderFns } from "./DTFAEdit.vue?vue&type=template&id=192fc3c4&"
import script from "./DTFAEdit.vue?vue&type=script&lang=js&"
export * from "./DTFAEdit.vue?vue&type=script&lang=js&"
import style0 from "./DTFAEdit.vue?vue&type=style&index=0&id=192fc3c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports